import Chapter from "@frog/source/models/Chapter.js"

export default class Game {
    static update(game, delta) {
        if(game.chapter != undefined
        && game.chapter.update != undefined) {
            game.chapter.update(delta)
        }
    }
    static load(game) {
        if(game.chapter != undefined) {
            game.chapter = Chapter.load({
                "chapter": game.chapter,
                "player": game.player,
                "gameslug": game.slug,
                "randomSeed": game.randomSeed,
            })
        }
        return game
    }
}
